import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ResponseMessageType,
  RawDraftContentState,
  PreviewWithFileType,
} from "~/domains";

type RequestDataType = {
  id: string;
  employeeSurveySubmissionId: string;
  body: {
    content: RawDraftContentState;
    attachFiles: PreviewWithFileType[];
    quotePostId?: string;
  };
};

const request = ({ id, employeeSurveySubmissionId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ reply: body });
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/members/employee_survey_submissions/${employeeSurveySubmissionId}/employee_survey_submission_replies/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersEmployeeSurveySubmissionsEmployeeSurveySubmissionRepliesUpdate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ResponseMessageType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
